import {z} from 'zod';

/**
 * Router location state of a page opened by the screen-pop when the viewer answered a call:
 * whose call it was, for the strip on top of the page.
 */
export const TelephonyScreenPopLocationStateSchema = z.object({
  telephonyScreenPop: z.object({callerName: z.string()}),
});

export type TelephonyScreenPopLocationState = z.infer<typeof TelephonyScreenPopLocationStateSchema>;
